import { UPDATE_USER, SET_SELECTED_TENANT } from "../constants/User";

const initUser = {
	name: null,
	role: null,
	tenants: [],
	selectedTenant: null,
	idGrupoUsuario: null,
};

const user = (state = initUser, action) => {
	switch (action.type) {
		case UPDATE_USER:
			return {
				...state,
				name: action.name,
				role: action.role,
				tenants:
					action.tenants !== undefined ? action.tenants : state.tenants,
				selectedTenant:
					action.selectedTenant !== undefined
						? action.selectedTenant
						: state.selectedTenant,
				idGrupoUsuario:
					action.idGrupoUsuario !== undefined
						? action.idGrupoUsuario
						: state.idGrupoUsuario,
			};
		case SET_SELECTED_TENANT:
			return {
				...state,
				selectedTenant: action.tenantSchema || null,
			};
		default:
			return state;
	}
};

export default user;
